import { AnalyticsContextValue } from "@swiggy-private/analytics";
import { CLICK_ACTIONS, IMPRESSION_ACTIONS, SCREEN_NAME } from "../constants";
import { IToingLpgImpressionParams } from "@cart-client/interfaces/ToingLpg";

export const impressionTopCartBannerD2C = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    { text, subText, cta, ...extraParams }: IToingLpgImpressionParams,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_TOP_CART_BANNER_D2C,
        context: JSON.stringify({ text, subText, cta }),
        extraParams: JSON.stringify(extraParams),
    });
};

export const clickTopCartBannerD2C = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    { text, subText, cta, ...extraParams }: IToingLpgImpressionParams,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_TOP_CART_BANNER_D2C,
        context: JSON.stringify({ text, subText, cta }),
        extraParams: JSON.stringify(extraParams),
    });
};

export const impressionNoAddressD2C = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    { text, subText, cta, ...extraParams }: IToingLpgImpressionParams,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_NO_ADDRESS_D2C,
        context: JSON.stringify({ text, subText, cta }),
        extraParams: JSON.stringify(extraParams),
    });
};

export const clickNoAddressD2C = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    { text, subText, cta, ...extraParams }: IToingLpgImpressionParams,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_NO_ADDRESS_D2C,
        context: JSON.stringify({ text, subText, cta }),
        extraParams: JSON.stringify(extraParams),
    });
};

export const impressionTutorialD2C = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    { text, subText = "", cta, ...extraParams }: IToingLpgImpressionParams,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_TUTORIAL_D2C,
        context: JSON.stringify({ text, subText, cta }),
        extraParams: JSON.stringify(extraParams),
    });
};

export const clickTutorialD2C = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    { text, subText, cta, ...extraParams }: IToingLpgImpressionParams,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_TUTORIAL_D2C,
        context: JSON.stringify({ text, subText, cta }),
        extraParams: JSON.stringify(extraParams),
    });
};

export const impressionScanningD2C = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    { state, text, subText, cta, ...extraParams }: IToingLpgImpressionParams,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_SCANNING_D2C,
        context: JSON.stringify({ text, subText, cta, state }),
        extraParams: JSON.stringify(extraParams),
    });
};

export const impressionResultD2C = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    { state, text, subText, cta, ...extraParams }: IToingLpgImpressionParams,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_RESULT_D2C,
        context: JSON.stringify({ text, subText, cta, state }),
        extraParams: JSON.stringify(extraParams),
    });
};

export const clickResultRejectD2C = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    { text, subText, cta, ...extraParams }: IToingLpgImpressionParams,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_RESULT_REJECT_D2C,
        context: JSON.stringify({ text, subText, cta }),
        extraParams: JSON.stringify(extraParams),
    });
};

export const clickCloseD2CHalfcard = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    { text, subText, cta, ...extraParams }: IToingLpgImpressionParams,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_CLOSE_D2C_HALF_CARD,
        context: JSON.stringify({ text, subText, cta }),
        extraParams: JSON.stringify(extraParams),
    });
};

export const impressionTimerToastD2C = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    { state, text, subText, cta, ...extraParams }: IToingLpgImpressionParams,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_TIMER_TOAST_D2C,
        context: JSON.stringify({ text, subText, cta }),
        extraParams: JSON.stringify(extraParams),
    });
};

export const impressionBackPressWarningD2C = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    { text, subText, cta, ...extraParams }: IToingLpgImpressionParams,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_FREE_CASH_WARNING_D2C,
        context: JSON.stringify({ text, subText, cta }),
        extraParams: JSON.stringify(extraParams),
    });
};

export const clickBackPressWarningD2C = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    { text, subText, cta, ...extraParams }: IToingLpgImpressionParams,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_FREE_CASH_WARNING_D2C,
        context: JSON.stringify({ text, subText, cta }),
        extraParams: JSON.stringify(extraParams),
    });
};

export const impressionTimerToastExpiryD2C = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    { text, subText, cta, ...extraParams }: IToingLpgImpressionParams,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_TIMER_TOAST_EXPIRY_D2C,
        context: JSON.stringify({ text, subText, cta }),
        extraParams: JSON.stringify(extraParams),
    });
};
